module.exports = __webpack_public_path__ + "fonts/boxicons.342c5275.eot";